import {httpsCallable} from "firebase/functions";
import {Functions, Auth} from "../../../firebase/firebase";

export async function makeAdmin(userID) {
    return httpsCallable(Functions, "call-auth-makeAdmin")({
        userID: userID,
        callerID: Auth.currentUser.uid,
        callerToken: await Auth.currentUser.getIdToken()
    });
}

export function checkAdmin() {
    Auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {
            console.log(idTokenResult.claims.admin);
        })
}
